<p>stats works!</p>
